import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import { MouseEventHandler } from 'react';

type DialogProps = {
  open: boolean;
  title: string;
  text: string;
  okText: string;
  ngText: string;
  onConfirm: () => void;
  onCancel?: () => void;
  onClose: () => void;
};

function AlertDialog(props: DialogProps) {
  const onConfirm: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault();
    props.onConfirm();
    props.onClose();
  };

  const onCancel: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault();
    props.onClose();
    if (props.onCancel) {
      props.onCancel();
    }
  };
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} autoFocus>
          {props.okText}
        </Button>
        <Button onClick={onCancel}>{props.ngText}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default AlertDialog;
